<template>
  <transition
    v-bind:css="false"
    v-on:enter="enter"
    v-on:leave="leave"
    appear
  >
    <div class="modal-overlay">
      <div class="modal-content">
        <button class="close-button" @click="handleClose"><close-icon/></button>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
import { TweenMax, Power4 } from 'gsap'
import CloseIcon from './icons/Close.vue'

export default {
  name: 'modal',
  components: {
    CloseIcon
  },
  methods: {
    enter (el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          alpha: 0
        },
        {
          alpha: 1,
          ease: Power4.easeOut
        }
      )
    },
    leave (el, done) {
      TweenMax.to(el, 0.5, {
        alpha: 0,
        ease: Power4.easeOut,
        onComplete: done
      })
    },
    handleClose () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/colors.scss";

.modal-overlay {
  display: flex;
  align-items: flex-start;
  background-color: rgba(0,0,0,.64);
  height: 100%;
  justify-content: center;
  left: 0;
  overflow-y: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}

.modal-content {
  background-color: #f8fbff;
  border-radius: 2px;
  display: block;
  margin: 48px 0 80px;
  overflow: hidden;
  position: relative;
  width: 768px;
  z-index: 25;
  padding: 15px;
}

.close-button {
  border: none;
  position: absolute;
  top: 0;
  right: 0;
  height: 32px;
  overflow: hidden;
  padding: 4px;
  margin: 4px;
  width: 32px;
  z-index: 2;
  background-color: transparent;
}
</style>
